import { createTheme } from "@mui/material/styles";

const primary = "#009556";
const ink = "#1F1A17";

export const theme = createTheme({
  palette: {
    primary: {
      main: primary,
      dark: "#007344",
      light: "#E6F6EE",
      contrastText: "#FFFFFF",
    },
    error: { main: "#D00539" },
    warning: { main: "#E6B800" },
    success: { main: primary },
    text: { primary: ink, secondary: "#5C5855" },
    background: { default: "#F4F7F4", paper: "#FFFFFF" },
  },
  typography: {
    fontFamily:
      'Manrope, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  shape: { borderRadius: 12 },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          borderRadius: 12,
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: primary,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: primary,
            borderWidth: 2,
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: "#8A9A8E",
          "&.Mui-checked": { color: primary },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#8A9A8E",
          "&.Mui-checked": { color: primary },
        },
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: primary,
            color: "#FFFFFF",
            "&:hover": { backgroundColor: "#007344" },
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 16,
          overflow: "hidden",
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "rgba(0, 149, 86, 0.1)",
          },
        },
      },
    },
    MuiAlert: {
      defaultProps: {
        closeText: "Fechar",
      },
    },
  },
});
